import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { I18N } from '../../../utils/i18n/i18n';

export interface TabItem {
    key: string;
    text: string;
}
@Component
export default class HybridTabs extends Vue {
    public selected: string = 'valid';
    public tabs: TabItem[] = [];
    @Watch('globalPudge', { immediate: true, deep: true })
    public async onEpicContext(globalPudge: any, globalPudgeOld: any) {
        const couponValidText = (this.$i18n.locale === I18N.EI18nLocale.Zn)
            ? '有效优惠券'
            : 'Valid Coupons';
        const couponInvalidText = (this.$i18n.locale === I18N.EI18nLocale.Zn)
            ? '无效优惠券'
            : 'Invalid Coupons';
        this.tabs = [{
            key: 'valid',
            text: couponValidText
        }, {
            key: 'invalid',
            text: couponInvalidText
        }];
    }
    public selectTab(val: string) {
        this.selected = val;
    }
}
